import { render, staticRenderFns } from "./NuevoConcepto.vue?vue&type=template&id=4a676fa2&"
import script from "./NuevoConcepto.vue?vue&type=script&lang=js&"
export * from "./NuevoConcepto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports